// polyfills
import 'babel-polyfill';
import 'element-closest';

// source
import './web';
import './configureWeb';
//import './configureTurbolinks';

// css
import '../css/main.less';



// WEBPACK FOOTER //
// ./config/module-publish/resources-skoda/js/index.js